import { render, staticRenderFns } from "./ContractComponent.vue?vue&type=template&id=1dc61052&scoped=true&"
import script from "./ContractComponent.vue?vue&type=script&lang=js&"
export * from "./ContractComponent.vue?vue&type=script&lang=js&"
import style0 from "./ContractComponent.vue?vue&type=style&index=0&id=1dc61052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc61052",
  null
  
)

export default component.exports